/* ==========================================================================
   VELUNE — お気に入り（ハート）
   保存先は localStorage のみ。Shopifyアプリもバックエンドも使わない。

   保存形式: localStorage['velune:favs:v1']
     { "v": 1, "items": [ { "id": "123", "h": "product-handle", "t": 1756800000000 } ] }
     - h（ハンドル）が実体キー。id は将来の同期用に持っておくだけ。
     - 新しい順に先頭へ積む。

   前提と対策:
     - ページはCDNキャッシュされるので、サーバー描画は必ず未登録状態。JSで水和する。
     - facets / quick-add / product-info / related-products がDOMを差し替えるので、
       クリックは document の委譲、状態はMutationObserverで貼り直す。
       ※ そのため DOM への書き込みは「値が変わるときだけ」行う。
          同じ値でも textContent 代入はミューテーションを積むので、
          ガードしないと observer → syncAll → 書き込み → observer … が永久に回る。
     - Safariプライベートモード等で localStorage が例外を投げるため全アクセスを try/catch。
       書き込みの成否は呼び出し元まで返す（保存できていないのに成功扱いにしない）。
     - 一覧の再取得が失敗しても保存済みお気に入りは消さない。
       「404＝本当に消えた」と「通信失敗＝不明」を必ず区別する。
   ========================================================================== */
(function () {
  'use strict';

  // theme.liquid と お気に入りページのセクション、両方から読まれても二重に束縛しない
  if (window.VeluneFav) return;

  var KEY = 'velune:favs:v1';
  var MAX = 200;
  var SEL = '[data-vl-fav]';
  var SECTION = 'velune-favorite-card';

  /* ---------------------------------------------------------------- storage */

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function read() {
    var raw = null;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      return [];
    }
    if (!raw) return [];
    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!parsed || !Array.isArray(parsed.items)) return [];

    var out = [];
    var seen = Object.create(null);
    for (var i = 0; i < parsed.items.length; i++) {
      var it = parsed.items[i];
      if (!it || !it.h) continue;
      var h = String(it.h);
      if (seen[h]) continue;
      seen[h] = true;
      out.push({ id: it.id ? String(it.id) : '', h: h, t: Number(it.t) || 0 });
    }
    return out;
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v: 1, items: items.slice(0, MAX) }));
      return true;
    } catch (e) {
      return false;
    }
  }

  function handleSet() {
    var items = read();
    var set = Object.create(null);
    for (var i = 0; i < items.length; i++) set[items[i].h] = true;
    return set;
  }

  function has(h) {
    return !!handleSet()[String(h)];
  }

  function add(h, id) {
    h = String(h);
    var items = read();
    for (var i = 0; i < items.length; i++) {
      if (items[i].h === h) return false;
    }
    items.unshift({ id: id ? String(id) : '', h: h, t: Date.now() });
    // 保存できたかどうかをそのまま返す（localStorage不可の端末で成功扱いにしない）
    return write(items);
  }

  function remove(h) {
    h = String(h);
    var items = read();
    var kept = [];
    var removed = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].h === h) {
        removed = true;
      } else {
        kept.push(items[i]);
      }
    }
    if (!removed) return false;
    return write(kept);
  }

  function emit(detail) {
    try {
      document.dispatchEvent(new CustomEvent('vl:favchange', { detail: detail || {} }));
    } catch (e) {
      /* 古いブラウザ: 何もしない（同期は次のイベントで拾われる） */
    }
  }

  /* ------------------------------------------------------------- DOM 書き込み */

  /* MutationObserver で監視している領域なので、値が変わるときだけ書く。
     同値の textContent 代入でもレコードは積まれ、無限ループになる。 */
  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function show(el, on) {
    if (!el) return;
    if (on) {
      if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
    } else if (!el.hasAttribute('hidden')) {
      el.setAttribute('hidden', '');
    }
  }

  /* ------------------------------------------------------------ hydration */

  function syncButtons(scope) {
    var set = handleSet();
    var nodes = (scope || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var h = node.getAttribute('data-product-handle');
      if (!h) continue;
      var on = !!set[h];
      node.classList.toggle('is-active', on);
      // 状態は aria-pressed だけで伝える。
      // aria-label を「削除」に差し替えると「削除が押されています」と読まれて意味が反転する。
      setAttr(node, 'aria-pressed', on ? 'true' : 'false');
      // title は視覚的なツールチップ。元から持っている（=アイコンのみの）ボタンにだけ付け替える。
      if (node.hasAttribute('title')) {
        setAttr(node, 'title', on ? 'お気に入りから削除' : 'お気に入りに追加');
      }
      // 商品ページの可視ラベル（＝そのままアクセシブル名になる）
      setText(node.querySelector('[data-vl-fav-label]'), on ? 'お気に入り登録済み' : 'お気に入りに追加');
    }
  }

  function syncCounts() {
    var n = read().length;
    var nodes = document.querySelectorAll('[data-vl-fav-count]');
    var label = n > 99 ? '99+' : String(n);
    for (var i = 0; i < nodes.length; i++) {
      setText(nodes[i], label);
      show(nodes[i], n > 0);
    }
    var links = document.querySelectorAll('[data-vl-fav-link]');
    for (var j = 0; j < links.length; j++) {
      links[j].classList.toggle('is-active', n > 0);
    }
  }

  function syncAll(scope) {
    syncButtons(scope);
    syncCounts();
  }

  /* ---------------------------------------------------------------- toast */

  var toastEl = null;
  var toastTimer = null;

  /* live region は中身が「後から変わった」ときだけ読まれる。
     メッセージ入りの要素をいきなり挿入すると1回目が読み飛ばされるので、
     init で空のまま先に置いておく。 */
  function ensureToast() {
    if (toastEl || !document.body) return;
    toastEl = document.createElement('div');
    toastEl.className = 'vl-fav-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
  }

  function toast(message) {
    ensureToast();
    if (!toastEl) return;
    setText(toastEl, message);
    // 一度リフローさせてからクラスを付ける（連打でもトランジションが走る）
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      if (!toastEl) return;
      toastEl.classList.remove('is-visible');
      // 消えた文言が読み上げ対象に残らないように空にする
      setText(toastEl, '');
    }, 1900);
  }

  /* ---------------------------------------------------------------- track */

  function track(eventName, handle) {
    try {
      if (typeof window.fbq === 'function' && eventName === 'add') {
        window.fbq('track', 'AddToWishlist', { content_type: 'product', content_ids: [handle] });
      }
    } catch (e) {
      /* pixel未読込などは無視 */
    }
    try {
      if (typeof window.gtag === 'function' && eventName === 'add') {
        window.gtag('event', 'add_to_wishlist', { items: [{ item_id: handle }] });
      }
    } catch (e) {
      /* 同上 */
    }
  }

  /* -------------------------------------------------------------- toggling */

  // 商品ごとに持つ。全体で1つにすると「違う商品を続けて押す」まで潰れてしまう。
  var lastToggleAt = Object.create(null);

  function toggleNode(node) {
    var h = node.getAttribute('data-product-handle');
    if (!h) return;

    // 同じ商品のキーリピート・連打で計測イベントまで連射されるのを止める。
    // 「押し間違えてすぐ押し直す」は通したいので、一覧の削除待ち（300ms）より短くする。
    var now = Date.now();
    if (now - (lastToggleAt[h] || 0) < 150) return;
    lastToggleAt[h] = now;

    var id = node.getAttribute('data-product-id');
    var wasOn = has(h);
    var ok = wasOn ? remove(h) : add(h, id);

    if (!ok) {
      // localStorage が使えない環境（プライベートブラウズ / 容量超過 など）
      toast('この端末ではお気に入りを保存できません');
      syncAll();
      return;
    }

    node.classList.remove('is-pop');
    void node.offsetWidth;
    node.classList.add('is-pop');

    syncAll();
    emit({ handle: h, active: !wasOn });
    track(wasOn ? 'remove' : 'add', h);
    toast(wasOn ? 'お気に入りから削除しました' : 'お気に入りに追加しました');
  }

  /* --------------------------------------------------------- favorites page */

  // busy フラグだと、描画中に来た再描画要求が捨てられて「読み込み中…」で固まる。
  // 世代番号にして「古い結果を捨てる／新しい要求は必ず走る」に変える。
  var renderGen = 0;

  function extractCard(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var wrapper = box.querySelector('.card-wrapper');
    if (wrapper) return { markup: wrapper.outerHTML };
    // セクションは返ってきたが商品が無い＝本当に削除／非公開
    if (box.querySelector('[data-vl-fav-missing]')) return { gone: true };
    return { failed: true };
  }

  /* 戻り値は3値。null に潰すと「取れなかった」と「消えた」の区別がつかなくなり、
     通信断でお気に入りを消してしまう。 */
  function fetchCard(handle) {
    var url = root().replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 404 || res.status === 410) return { gone: true };
        if (!res.ok) return { failed: true };
        return res.text().then(function (text) {
          return text ? extractCard(text) : { failed: true };
        });
      })
      .catch(function () {
        // オフライン・回線瞬断・拡張機能によるブロック
        return { failed: true };
      });
  }

  function favPageNodes() {
    var page = document.querySelector('[data-vl-favpage]');
    if (!page) return null;
    var grid = page.querySelector('[data-vl-fav-grid]');
    if (!grid) return null;
    return {
      page: page,
      grid: grid,
      empty: page.querySelector('[data-vl-fav-empty]'),
      loading: page.querySelector('[data-vl-fav-loading]'),
      error: page.querySelector('[data-vl-fav-error]'),
      counter: page.querySelector('[data-vl-favpage-count]')
    };
  }

  function countLabel(n, failed) {
    if (!n) return '';
    if (failed > 0) return n + ' 点（' + failed + ' 点は読み込めませんでした）';
    return n + ' 点';
  }

  function renderFavPage() {
    var n = favPageNodes();
    if (!n) return;

    var gen = ++renderGen;
    var items = read();

    if (!items.length) {
      setText(n.grid, '');
      show(n.grid, false);
      show(n.loading, false);
      show(n.error, false);
      show(n.empty, true);
      setText(n.counter, '');
      return;
    }

    show(n.empty, false);
    show(n.error, false);
    show(n.loading, true);

    var results = new Array(items.length);
    var cursor = 0;
    var inFlight = 0;
    var finished = false;
    var LIMIT = 4;

    function done() {
      if (finished) return;
      finished = true;
      // 自分より新しい描画が始まっていたら、この結果は捨てる
      if (gen !== renderGen) return;
      // セクションが差し替わっている可能性があるのでDOMを取り直す
      var d = favPageNodes();
      if (!d) return;

      var rendered = 0;
      var markup = '';
      for (var i = 0; i < results.length; i++) {
        if (results[i] && results[i].markup) {
          rendered++;
          markup +=
            '<li class="grid__item" data-vl-fav-cell data-handle="' + items[i].h + '">' + results[i].markup + '</li>';
        }
      }

      // 1件でも描けていれば取得の仕組みは生きている＝404は「本当に消えた商品」と信じてよい。
      // 全滅のときはセクション欠落・回線断・障害の可能性が高いので、1件も削除しない。
      var canPrune = rendered > 0;

      var keep = [];
      var gone = Object.create(null);
      var failed = 0;
      for (var j = 0; j < results.length; j++) {
        var r = results[j];
        if (r && r.markup) {
          keep.push(items[j]);
        } else if (r && r.gone && canPrune) {
          gone[items[j].h] = true;
        } else {
          // 取得失敗（または削除判定を保留）。保存は絶対に消さない。カードを出さないだけ。
          keep.push(items[j]);
          failed++;
        }
      }

      if (canPrune) {
        // スナップショットではなく「いまの保存内容」から消す（別タブの追加を巻き戻さない）
        var current = read();
        var next = [];
        for (var c = 0; c < current.length; c++) {
          if (!gone[current[c].h]) next.push(current[c]);
        }
        if (next.length !== current.length) write(next);
      }

      d.grid.innerHTML = markup;
      show(d.loading, false);
      show(d.grid, rendered > 0);
      // 保存が空のときだけ「空」。取得失敗で0件描画のときは空扱いにしない。
      show(d.empty, keep.length === 0);
      show(d.error, keep.length > 0 && rendered === 0);
      setText(d.counter, countLabel(keep.length, failed));
      syncAll();
    }

    function pump() {
      while (inFlight < LIMIT && cursor < items.length) {
        (function (index) {
          inFlight++;
          fetchCard(items[index].h).then(function (r) {
            results[index] = r;
            inFlight--;
            if (cursor >= items.length && inFlight === 0) {
              done();
            } else {
              pump();
            }
          });
        })(cursor);
        cursor++;
      }
      if (cursor >= items.length && inFlight === 0) done();
    }

    pump();
  }

  // 一覧ページでハートを外したら、その場でカードを畳む（再フェッチしない）
  var pruneTimers = Object.create(null);

  function favCell(page, handle) {
    return page.querySelector('[data-vl-fav-cell][data-handle="' + handle + '"]');
  }

  // 消えるセルにフォーカスが載っていたら、隣のハートへ渡す（bodyへ飛ばさない）
  function moveFocusOut(cell) {
    if (!cell.contains(document.activeElement)) return;
    var next = cell.nextElementSibling || cell.previousElementSibling;
    var target = next ? next.querySelector(SEL) : null;
    if (!target) {
      var page = document.querySelector('[data-vl-favpage]');
      target = page ? page.querySelector('[data-vl-favpage-count]') : null;
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    }
    if (target) {
      try {
        target.focus();
      } catch (e) {
        /* 無視 */
      }
    }
  }

  function pruneFavPageCell(handle) {
    var page = document.querySelector('[data-vl-favpage]');
    if (!page) return;
    var cell = favCell(page, handle);
    if (!cell) return;
    if (pruneTimers[handle]) clearTimeout(pruneTimers[handle]);
    cell.classList.add('is-leaving');
    pruneTimers[handle] = setTimeout(function () {
      delete pruneTimers[handle];
      moveFocusOut(cell);
      if (cell.parentNode) cell.parentNode.removeChild(cell);
      var d = favPageNodes();
      if (!d) return;
      var left = d.grid.querySelectorAll('[data-vl-fav-cell]').length;
      setText(d.counter, countLabel(left, 0));
      if (!left) {
        show(d.grid, false);
        show(d.empty, true);
      }
      // CSSのフェード（0.3s）と揃える。ここを押し直しのレート制限より長く取ることで、
      // 「消える前に押し直したら戻る」が成立する。
    }, 300);
  }

  // 消える前（300ms以内）に押し直されたら、削除予約を取り消してカードを戻す
  function unpruneFavPageCell(handle) {
    if (pruneTimers[handle]) {
      clearTimeout(pruneTimers[handle]);
      delete pruneTimers[handle];
    }
    var page = document.querySelector('[data-vl-favpage]');
    if (!page) return;
    var cell = favCell(page, handle);
    if (cell) cell.classList.remove('is-leaving');
  }

  /* --------------------------------------------------------------- binding */

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var node = target.closest(SEL);
      if (!node) return;
      // カード全体を包む <a> のナビゲーションを止める
      e.preventDefault();
      e.stopPropagation();
      toggleNode(node);
    },
    true
  );

  function isSpace(e) {
    return e.key === ' ' || e.key === 'Spacebar';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && !isSpace(e)) return;
    var target = e.target;
    if (!target || !target.closest) return;
    var node = target.closest(SEL);
    if (!node) return;
    // Space はページスクロールだけ止めて、実行は keyup（ネイティブの button と同じ）
    e.preventDefault();
    e.stopPropagation();
    if (e.repeat) return;
    if (e.key === 'Enter') toggleNode(node);
  });

  document.addEventListener('keyup', function (e) {
    if (!isSpace(e)) return;
    var target = e.target;
    if (!target || !target.closest) return;
    var node = target.closest(SEL);
    if (!node) return;
    e.preventDefault();
    e.stopPropagation();
    toggleNode(node);
  });

  document.addEventListener('vl:favchange', function (e) {
    var detail = e && e.detail;
    if (!detail || !detail.handle) return;
    if (detail.active === false) {
      pruneFavPageCell(detail.handle);
    } else {
      unpruneFavPageCell(detail.handle);
    }
  });

  // 別タブでの変更を反映
  window.addEventListener('storage', function (e) {
    if (e && e.key && e.key !== KEY) return;
    syncAll();
    renderFavPage();
  });

  // Safari の bfcache 復帰では DOMContentLoaded が発火しない
  window.addEventListener('pageshow', function (e) {
    syncAll();
    // 戻るで復帰したときは、別ページで外した商品がカードとして残る
    if (e && e.persisted) renderFavPage();
  });

  // facets / quick-add / product-info によるDOM差し替え後に貼り直す
  var moTimer = null;
  function startObserver() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      if (moTimer) clearTimeout(moTimer);
      moTimer = setTimeout(function () {
        syncAll();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    ensureToast();
    syncAll();
    renderFavPage();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションが再描画されたとき
  document.addEventListener('shopify:section:load', function () {
    syncAll();
    renderFavPage();
  });

  /* ------------------------------------------------------------------- API */

  window.VeluneFav = {
    key: KEY,
    list: read,
    count: function () {
      return read().length;
    },
    has: has,
    add: function (h, id) {
      var r = add(h, id);
      if (r) {
        syncAll();
        emit({ handle: String(h), active: true });
      }
      return r;
    },
    remove: function (h) {
      var r = remove(h);
      if (r) {
        syncAll();
        emit({ handle: String(h), active: false });
      }
      return r;
    },
    clear: function () {
      var ok = write([]);
      syncAll();
      renderFavPage();
      emit({ handle: null, active: false });
      return ok;
    },
    refresh: function () {
      syncAll();
      renderFavPage();
    }
  };
})();
